// Account endpoints (docs/API.md §2). Email changes go through a
// Google-verified re-link (POST /me/email/change-start, completed by
// GET /auth/callback) rather than a direct PATCH — see Account.tsx for the
// button that starts it and the ?email_change= outcome banner.

import { apiGet, apiPost } from "@/lib/api";
import type { EmailChangeStartResponse, ReferralSummary, User } from "@/lib/types";

export function getMe(signal?: AbortSignal): Promise<User> {
  return apiGet<User>("/me", { signal });
}

/** Own referral code, signup count, and commission ledger (docs/API.md). */
export function getReferral(signal?: AbortSignal): Promise<ReferralSummary> {
  return apiGet<ReferralSummary>("/me/referral", { signal });
}

/** Starts the Google-verified email-change re-link: the server stashes a
 *  one-time intent (10 min TTL) and hands back the Google consent URL to
 *  redirect the browser to. `returnTo` must share its origin with the oauth
 *  redirect allowlist (docs/superpowers/plans/2026-07-19-email-change.md) —
 *  the server 400s `validation` otherwise. Completion lands back on
 *  `returnTo` with `?email_change=ok|conflict|denied` (Account.tsx reads it). */
export function startEmailChange(returnTo: string): Promise<string> {
  return apiPost<EmailChangeStartResponse>("/me/email/change-start", { return_to: returnTo }).then(
    (res) => res.authorize_url,
  );
}
